import { useAppSelector } from '@/app/hooks';
import { selectIsNonPaying } from '@/features/workspace/workspaceSlice';
import ChangePlanDialog from './ChangePlanDialog';
import UsageExpiredAlert from './UsageExpiredAlert';

/**
 * Déclencheur d'upsell affiché quand une limite de plan est atteinte (users / présentateurs).
 * Compte gratuit (NONE) : aucun abonnement Stripe → souscription depuis zéro (`UsageExpiredAlert`,
 * flux `createSubscription`). Abonné existant : changement de forfait (`ChangePlanDialog`, upgrade).
 */
export default function LimitUpsellDialog() {
  const isNonPaying = useAppSelector(selectIsNonPaying);
  return isNonPaying ? <UsageExpiredAlert isConfig /> : <ChangePlanDialog />;
}
